import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { MarketingNav } from './MarketingNav';
import { MarketingFooter } from './MarketingFooter';

export function MarketingLayout() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
  }, [pathname]);

  return (
    <div
      className="min-h-screen bg-[#0a0a1a] text-white overflow-x-hidden selection:bg-[#4f46e5]/40"
      style={{ fontFamily: "'DM Sans', system-ui, sans-serif" }}
    >
      <MarketingNav />
      <main>
        <Outlet />
      </main>
      <MarketingFooter />
    </div>
  );
}
